import { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { BoxButtons } from 'src/components/BoxButton'
import { CheckboxComponent } from 'src/components/Checkbox'
import { FormControlLabel } from 'src/components/FormControlLabel'
import { Stepper } from 'src/components/Stepper'
import DataContext from 'src/contexts/DataContext'
import * as S from './styles'
import { composePath } from 'src/utils'

const InstructionsPage = () => {
  const navigate = useNavigate()
  const { registration, setRegistration } = useContext(DataContext)
  const currentStep = registration.getStep(registration, 'instructions')
  const [isCheckboxDisabled, setIsCheckboxDisabled] = useState<boolean>(false)

  return (
    <S.Content>
      <Stepper
        currentStepName={currentStep?.name}
        label={currentStep?.title}
        course={registration.course}
      />
      <S.Title>
        Atenção! Informações sobre o NOVO programa de bolsas de estudos 2026
      </S.Title>

      <S.Paragraph>
        A partir do ano letivo de <S.Strong>2026</S.Strong>, a mensalidade
        integral do Instituto J&F será de <S.Strong>R$ 15.000,00</S.Strong>, com
        reajuste anual, aplicável apenas para novas matrículas.
      </S.Paragraph>
      <S.Paragraph>
        Temos uma política de bolsas voltada à promoção da equidade no acesso à
        educação:
      </S.Paragraph>
      <S.Paragraph>
        <S.List>
          <S.ItemList>
            <S.Strong>Alunos vindos de escolas públicas</S.Strong> terão{' '}
            <S.Strong>bolsa integral (100%);</S.Strong>
          </S.ItemList>
          <S.ItemList>
            <S.Strong>Alunos vindos de escolas particulares</S.Strong> poderão
            receber <S.Strong>bolsa parcial</S.Strong>, proporcional ao valor da
            última mensalidade paga na escola de origem.
          </S.ItemList>
        </S.List>
      </S.Paragraph>
      <S.Paragraph>
        <S.Strong>Exemplos práticos:</S.Strong>
      </S.Paragraph>
      <S.Paragraph>
        Se o aluno comprovar que pagava R$ 1.500,00 na escola anterior, pagará
        esse mesmo valor no Instituto J&F, recebendo assim uma{' '}
        <S.Strong>bolsa de 90%</S.Strong> do valor total da mensalidade do
        Instituto J&F.
      </S.Paragraph>
      <S.Paragraph>
        <S.Strong>Importante:</S.Strong> O{' '}
        <S.Strong>último boleto quitado</S.Strong> da escola de origem deverá
        ser apresentado na <S.Strong>Entrevista</S.Strong>, última etapa do
        processo de admissão.
      </S.Paragraph>
      <S.Paragraph>
        A <S.Strong>não apresentação</S.Strong> deste comprovante acarretará na{' '}
        <S.Strong>desclassificação do candidato</S.Strong>!
      </S.Paragraph>
      <S.Paragraph>A Escola é responsável por fornecer:</S.Paragraph>
      <S.Paragraph>
        <S.List>
          <S.ItemList>Alimentação</S.ItemList>
          <S.ItemList>Uniforme</S.ItemList>
          <S.ItemList>Notebook individual</S.ItemList>
          <S.ItemList>Saídas pedagógicas</S.ItemList>
        </S.List>
      </S.Paragraph>

      <FormControlLabel
        control={
          <CheckboxComponent
            checked={isCheckboxDisabled}
            onClick={() => setIsCheckboxDisabled((old) => !old)}
          />
        }
        label={
          <S.CheckBoxLabel>
            <S.Strong>
              Confirmo que li e compreendi todas as informações acima, e que
              estou de acordo com o Manual do Candidato, disponível em{' '}
              <a href="https://institutojef.org.br/" target="_blank">
                https://institutojef.org.br/
              </a>
              .
            </S.Strong>
          </S.CheckBoxLabel>
        }
      />

      <BoxButtons
        onClickPrevius={() => navigate(`/admissao/${registration.course}`)}
        onClickNext={() =>
          navigate(
            composePath('/documentos', `admissao/${registration.course}`)
          )
        }
        disableNextButton={!isCheckboxDisabled}
      />
    </S.Content>
  )
}

export { InstructionsPage }
